import React, {
  useEffect,
  useRef,
  useState
} from 'react'
import { Box } from '@mui/material'
import DaysCalendarPicker from '../daysCalendarPicker/DaysCalendarPicker'
import DateRangePickersWithWeekDays, { DateRangeField } from '../dateRangePickerWithWeekDays/DateRangePickersWithWeekDays'
import { DateDataList } from 'src/api'
import moment from 'moment'
import { momentAdapter } from 'src/adapters'
import OptionSwitch from '../optionSwitch/OptionSwitch'
import { useTranslation } from 'react-i18next'

export type SwitchableDateRangePickerDateRangeType = 'single'| 'range'
interface Props {
  onChange?: (dates:DateDataList[]) => void
  error?: string
}
const SwitchableDateRangePicker:ReactFC<Props> = ({
  onChange,
  error
}) => {
  const [selectedDays, setSelectedDays] = useState<Date[]>([])
  const daysCalendarPickerEl = useRef<HTMLDivElement>()
  const [selectedDateRanges, setSelectedDateRanges] = useState<DateRangeField[]>([])
  const [dateRangeType, setDateRangeType] = useState<'single'| 'range'>('range')
  const containerEl = useRef<HTMLDivElement>()
  const { t } = useTranslation()

  useEffect(() => {
    if (error) {
      containerEl.current?.scrollIntoView({
        block: 'nearest'
      })
    }
  }, [error])

  useEffect(() => {
    if (dateRangeType === 'single') {
      daysCalendarPickerEl.current?.scrollIntoView({
        block: 'nearest'
      })
    }
  }, [dateRangeType])

  const handleSwitchDateType = () => {
    if (dateRangeType === 'single') {
      setDateRangeType('range')
      setSelectedDays([])
      return
    }
    setDateRangeType('single')
    setSelectedDateRanges([])
  }

  const handleChangeSelectedDays = (newDays: Date[]) => {
    setSelectedDays(newDays)
    onChange?.(newDays.map(day => ({
      iniDate: momentAdapter.toString(moment(day)),
      endDate: momentAdapter.toString(moment(day)),
      friday: true,
      monday: true,
      saturday: true,
      sunday: true,
      thursday: true,
      tuesday: true,
      wednesday: true
    })))
  }

  const handleChangeDateRanges = (newDateRanges:DateRangeField[]) => {
    setSelectedDateRanges(newDateRanges)
    onChange?.(newDateRanges.map(({
      dateRange: [iniDate, endDate],
      daysOfWeek
    }) => ({
      iniDate: momentAdapter.toString(moment(iniDate)),
      endDate: momentAdapter.toString(moment(endDate)),
      ...daysOfWeek
    })))
  }

  return (
    <Box>
      <OptionSwitch
        checked={dateRangeType === 'single'}
        onChange={handleSwitchDateType}
        labels={[t('labels.Days'), t('labels.Range')]}
      />
      <Box
        ref={containerEl}
        sx={{
          marginTop: '1rem'
        }}
      >
        {
          dateRangeType === 'single'
            ? (
                <DaysCalendarPicker
                  ref={daysCalendarPickerEl}
                  onChange={handleChangeSelectedDays}
                  selectedDates={selectedDays}
                  calendarProps={{
                    disablePast: true
                  }}
                  error={error}
                />
              )
            : (
                <DateRangePickersWithWeekDays
                  onChange={handleChangeDateRanges}
                  dateRanges={selectedDateRanges}
                  error={error}
                />
              )
        }
      </Box>
    </Box>
  )
}
export default SwitchableDateRangePicker
